export default __webpack_public_path__ + "static/media/news83.00bcdac5.jpg";